import { Spinner, Box } from "@shopify/polaris";
import styled from "styled-components";

const StyledLoader = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
`;

const Loader = ({ size = "large" }) => (
  <StyledLoader>
    <Spinner size={size} />
  </StyledLoader>
);

export default Loader;
